import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=2b4d3ad3&scoped=true&"
import script from "./IconLink.vue?vue&type=script&lang=js&"
export * from "./IconLink.vue?vue&type=script&lang=js&"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=2b4d3ad3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d3ad3",
  null
  
)

export default component.exports